<p-dialog
  [header]="getDialogHeading()"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '1000px' }"
  [responsive]="true"
  (onHide)="onHide()"
>
  <div *ngIf="prefilledFromBookingSummary" class="prefill-banner">
    <div class="flex grid-gap-10">
      <div class="flex-shrink-1 prefill-banner-icon">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="flex-grow-1">
        <div class="prefill-banner-title">
          {{ prefilledFromBookingSummary }} have been copied from the booking form
        </div>
        <div>Please ensure they are correct before saving</div>
      </div>
    </div>
  </div>

  <form
    *ngIf="editSitesForm"
    [formGroup]="editSitesForm"
    (ngSubmit)="saveSite()"
    autocomplete="off"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-6 ui-sm-12 grid">
          <div class="ui-g-4">
            <label for="sitename">Internal Site Name</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.siteName"
              autocomplete="off"
              id="sitename"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="businessname">Business Name</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.businessName"
              autocomplete="off"
              id="businessname"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="address1">Address Line 1</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.address1"
              autocomplete="off"
              id="address1"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="address2">Address Line 2</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.address2"
              autocomplete="off"
              id="address2"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="address3">Address Line 3</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.address3"
              autocomplete="off"
              id="address3"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="city">Town</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              [formControl]="editSitesForm.controls.city"
              autocomplete="off"
              id="city"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <label for="postcode">Postcode</label>
          </div>
          <div class="ui-g-4">
            <input
              pInputText
              [formControl]="editSitesForm.controls.postcode"
              [postcodeFormat]
              autocomplete="off"
              id="postcode"
              class="border-validation"
            />
          </div>
          <div class="ui-g-4">
            <button
              type="button"
              class="set-on-map green-btn ui-button"
              pButton
              icon="fa fa-map-marker"
              label="Set on Map"
              (click)="searchAddress()"
              [disabled]="editSitesForm.invalid"
            ></button>
          </div>
          <div class="ui-g-4">
            <label for="what3Words">What3Words</label>
          </div>
          <div class="ui-g-8">
            <div class="ui-inputgroup">
              <span class="ui-inputgroup-addon"><what3words-logo></what3words-logo></span>
              <input
                pInputText
                [formControl]="editSitesForm.controls.what3Words"
                (paste)="removeSlashesOnPaste($event)"
                autocomplete="off"
                id="what3Words"
                class="border-validation"
                placeholder="what.three.words"
              />
            </div>
          </div>

          <div class="ui-g-4">
            <label>Release Code (If Applicable)</label>
          </div>
          <div class="ui-g-8">
            <input
              pInputText
              maxlength="6"
              [formControl]="editSitesForm.controls.releaseCode"
              autocomplete="off"
              id="releaseCode"
            />
          </div>

          <div class="ui-g-4">
            <label>Site Open Hours</label>
          </div>
          <div class="ui-g-8">
            <overlay-panel-input
              *ngIf="openingTimesForm"
              [invalid]="openingTimesForm.invalid"
              [overlayPanelRef]="siteHoursForm"
              text="Add/Edit Hours"
            ></overlay-panel-input>
          </div>

          <div class="ui-g-4">
            <label>Disabled?</label>
          </div>
          <div class="ui-g-8">
            <p-checkbox binary="true" [formControl]="editSitesForm.controls.disabled"></p-checkbox>
          </div>

          <div class="ui-g-4">
            <label>Appear in Drop-Off Suggestions?</label>
          </div>
          <div class="ui-g-8">
            <p-checkbox
              binary="true"
              [formControl]="editSitesForm.controls.nearestLocationMatchEnabled"
              [disabled]="!isUserImpersonated"
            ></p-checkbox>
          </div>

          <div class="ui-g-4" *ngIf="isUserImpersonated">
            <label>VehicleLifeCycle - Max Site Capacity</label>
          </div>
          <div class="ui-g-8" *ngIf="isUserImpersonated">
            <input
              pInputText
              [formControl]="editSitesForm.controls.vehicleLifeCycleMaxCapacity"
              autocomplete="off"
              id="vehicleLifeCycleMaxCapacity"
            />
          </div>

          <div class="ui-g-4" *ngIf="editSitesForm.get('id').value > 0">Vehicle LifeCycle</div>
          <div class="ui-g-4" *ngIf="editSitesForm.get('id').value > 0">
            <input
              type="button"
              pButton
              value="Configure Providers"
              (click)="configureLifeCycleCustomerSitesProviders()"
              class="vlc-provider-config-btn"
            />
          </div>

          <p-tabView [className]="'ui-g-12'">
            <p-tabPanel header="Pickup Contact">
              <div class="ui-g-12 ui-md-2">
                <label for="forename">Name</label>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.pickupForename"
                  placeholder="Forename"
                  id="forename"
                />
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.pickupSurname"
                  placeholder="Surname"
                />
              </div>

              <!--- NEW LINE -->

              <div class="ui-g-12 ui-md-2">
                <label for="pickupEmail">E-mail</label>
              </div>

              <div class="ui-g-12 ui-md-10">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.pickupEmail"
                  id="pickupEmail"
                />
              </div>

              <!-- NEW LINE -->

              <div class="ui-g-12 ui-md-2">
                <label for="pickupPhone1">Mobile</label>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.pickupPhone1"
                  id="pickupPhone1"
                />
                <div *ngIf="pickupPhone1Error != ''" class="text-danger">
                  {{ pickupPhone1Error }}
                </div>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.pickupPhone2"
                  placeholder="Alternative Number"
                />
                <div *ngIf="pickupPhone2Error != ''" class="text-danger">
                  {{ pickupPhone2Error }}
                </div>
              </div>

              <!--- NEW LINE -->

              <div class="ui-g-2">
                <label for="pickupNotes">Notes</label>
              </div>

              <div class="ui-g-10">
                <textarea
                  pInputTextarea
                  style="width: 100%"
                  [formControl]="editSitesForm.controls.pickupNotes"
                  id="pickupNotes"
                ></textarea>
              </div>

              <div class="ui-g-12">
                <button
                  type="button"
                  pButton
                  label="Clear"
                  class="btn-to-right pull-right"
                  (click)="clearContactConfirm(true)"
                ></button>
              </div>

              <div style="clear: both"></div>
            </p-tabPanel>

            <p-tabPanel header="Dropoff Contact">
              <div class="ui-g-12 ui-md-2">
                <label for="dropoffForename">Name</label>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.dropoffForename"
                  id="dropoffForename"
                  placeholder="Forename"
                />
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.dropoffSurname"
                  placeholder="Surname"
                />
              </div>

              <!--- NEW LINE -->

              <div class="ui-g-12 ui-md-2">
                <label for="dropoffEmail">E-mail</label>
              </div>

              <div class="ui-g-12 ui-md-10">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.dropoffEmail"
                  id="dropoffEmail"
                />
              </div>

              <!-- NEW LINE -->

              <div class="ui-g-12 ui-md-2">
                <label for="dropoffPhone1">Mobile</label>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.dropoffPhone1"
                  id="dropoffPhone1"
                />
                <div *ngIf="dropoffPhone1Error != ''" class="text-danger">
                  {{ dropoffPhone1Error }}
                </div>
              </div>

              <div class="ui-g-12 ui-md-5">
                <input
                  style="width: 100%"
                  pInputText
                  [formControl]="editSitesForm.controls.dropoffPhone2"
                  placeholder="Alternative Number"
                />
                <div *ngIf="dropoffPhone2Error != ''" class="text-danger">
                  {{ dropoffPhone2Error }}
                </div>
              </div>

              <!--- NEW LINE -->

              <div class="ui-g-2">
                <label for="dropoffNotes">Notes</label>
              </div>

              <div class="ui-g-10">
                <textarea
                  pInputTextarea
                  style="width: 100%"
                  [formControl]="editSitesForm.controls.dropoffNotes"
                  id="dropoffNotes"
                ></textarea>
              </div>

              <div>
                <div class="ui-g-2">&nbsp;</div>
                <div class="ui-g-10">
                  <p-checkbox
                    binary="true"
                    [formControl]="editSitesForm.controls.dropoffNotification"
                  ></p-checkbox>
                  Send Notifications
                </div>
              </div>

              <div class="ui-g-12">
                <button
                  type="button"
                  pButton
                  label="Clear"
                  class="btn-to-right pull-right"
                  (click)="clearContactConfirm(false)"
                ></button>
              </div>

              <div style="clear: both"></div>
            </p-tabPanel>
          </p-tabView>
        </div>

        <div class="ui-g-6 ui-sm-12">
          <div id="ajustementMap">
            <div class="ui-g-6" style="float: right; width: 100%">
              <map-control
                [readOnlyMode]="4"
                [lazyLoad]="true"
                [origin]="siteMarkerPoint"
                (originChange)="onManualCoordinateChange($event)"
                [customStyle]="{ height: '400px' }"
              >
              </map-control>
            </div>
          </div>

          <div class="icon-explain">
            You can set the exact location by dragging+dropping the icon above.
          </div>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <div class="button-box">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="closeDialog()"
      ></button>
      <span
        [pTooltip]="
          !currentAddressValidated || editSitesForm?.invalid
            ? 'Click \'Set on Map\' to re-validate the input'
            : ''
        "
        tooltipPosition="top"
      >
        <button
          type="submit"
          class="green-btn"
          pButton
          icon="fa ui-icon-check"
          [label]="getSaveButtonLabel()"
          [disabled]="
            !currentAddressValidated || editSitesForm?.invalid || openingTimesForm.invalid
          "
          (click)="saveSite()"
        ></button>
      </span>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  header="Manage Vehicle LifeCycle Site Configuration"
  [(visible)]="vehicleLifeCycleManageProvidersVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px', height: '350px' }"
>
  <div>
    <div class="col-12 mb-4">
      <strong>
        Please select a provider from the list below to configure the required site mappings. If a
        provider you expect to see is not in the list, please check if it has been enabled for the
        current customer account.
      </strong>
    </div>
    <div class="col-12 mb-4">
      <div class="ui-grid-col-4">
        <label><strong>Provider</strong></label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="vehicleLifeCycleProviderConnections"
          [optionLabel]="'providerName'"
          [dataKey]="'id'"
          [autoDisplayFirst]="false"
          styleClass="form-component"
          (onChange)="selectProviderConfiguration($event.value)"
          placeholder="Select Provider"
          [(ngModel)]="vehicleLifeCycleSelectedProvider"
        >
        </p-dropdown>
      </div>
    </div>
    <form
      *ngIf="vehicleLifeCycleCustomerSiteProviderFormGroup"
      [formGroup]="vehicleLifeCycleCustomerSiteProviderFormGroup"
    >
      <div class="ui-g-12" style="margin-bottom: 50px">
        <div class="ui-grid-col-4">
          <label for="externalSiteId"><strong>External Site ID</strong></label>
        </div>
        <div class="ui-grid-col-8">
          <input
            pInputText
            class="form-component"
            formControlName="externalSiteId"
            id="externalSiteId"
          />
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        class="btn-to-right"
        label="Save Changes"
        pButton
        type="button"
        [disabled]="
          !vehicleLifeCycleCustomerSiteProviderFormGroup?.valid ||
          vehicleLifeCycleProviderUpdateSaving
        "
        (click)="saveLifeCycleProviderConnection()"
      ></button>
      <button
        class="btn-to-right"
        label="Close"
        pButton
        type="button"
        (click)="vehicleLifeCycleManageProvidersVisible = false"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-overlayPanel #siteHoursForm class="no-padding" [dismissable]="true">
  <customer-sites-opening-times
    *ngIf="openingTimesForm"
    [openingTimesForm]="openingTimesForm"
    (onClose)="closeSiteHoursForm()"
    #customerSitesOpeningTimes
  ></customer-sites-opening-times>
</p-overlayPanel>
